var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximizedButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_54_1228)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#D9D9D9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "#434343",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0528 18.3889H13.582C14.0065 18.3889 14.367 18.5375 14.6635 18.8347C14.9601 19.1319 15.1083 19.4932 15.1083 19.9187C15.1083 20.3442 14.9601 20.7044 14.6635 20.9993C14.367 21.2942 14.0065 21.4417 13.582 21.4417H8.52638C8.10185 21.4417 7.74132 21.2934 7.44479 20.9969C7.14826 20.7003 7 20.3398 7 19.9153V14.8597C7 14.4352 7.14859 14.0747 7.44578 13.7781C7.74295 13.4816 8.10429 13.3333 8.52979 13.3333C8.95529 13.3333 9.3155 13.4816 9.61042 13.7781C9.90531 14.0747 10.0528 14.4352 10.0528 14.8597V18.3889ZM17.3889 11.0528H13.8597C13.4352 11.0528 13.0747 10.9042 12.7781 10.607C12.4816 10.3098 12.3333 9.94847 12.3333 9.52297C12.3333 9.09746 12.4816 8.73726 12.7781 8.44237C13.0747 8.14746 13.4352 8 13.8597 8H18.9153C19.3398 8 19.7003 8.14826 19.9969 8.44479C20.2934 8.74132 20.4417 9.10185 20.4417 9.52638V14.582C20.4417 15.0065 20.2931 15.367 19.9959 15.6635C19.6987 15.9601 19.3374 16.1083 18.9119 16.1083C18.4864 16.1083 18.1262 15.9601 17.8313 15.6635C17.5364 15.367 17.3889 15.0065 17.3889 14.582V11.0528Z",
    fill: "#434343"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_54_1228",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_54_1228"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizedButton);
export default __webpack_public_path__ + "static/media/maximizedButton.08091c149c25a86f92577aaf6e6138e0.svg";
export { ForwardRef as ReactComponent };